export default __webpack_public_path__ + "static/media/player_0_eliminated.964e9727.png";